import { AnyAction } from 'redux';
import { get, post } from '@eika-infrastruktur/request';
import {
    StorebrandApi,
    StorebrandContract,
    SwitchStorebrandSavingsProfilePayload,
    SwitchStorebrandSavingsProfileResponseApi,
} from '../domain/Storebrand';
import { TDispatch } from '../domain/State';

const baseUrlFond = '/sparing-min-side-web/rest/resource/pension/storebrand';
export const SET_STOREBRAND_TRANSACTION = 'SET_STOREBRAND_TRANSACTION';
export const SET_STOREBRAND_PENSION_PAYOUT = 'SET_STOREBRAND_PENSION_PAYOUT';
export const SET_STOREBRAND_INFO = 'SET_STOREBRAND_INFO';

const mapStorebrandData = (data: StorebrandApi | null) => {
    const pin: Record<string, StorebrandContract> = {};
    if (data) {
        ['epks', 'pkbs'].forEach((key) => {
            (data?.[key as keyof StorebrandApi] ?? []).forEach((info) => {
                pin[info.contractId] = info;
            });
        });
    }
    return pin;
};

export const getStorebrandInfo = (callback?: (result: StorebrandApi | null) => void) => async (dispatch: TDispatch) => {
    let result: StorebrandApi | null;

    try {
        result = await get<StorebrandApi>(baseUrlFond).catch(() => null);
    } catch (error) {
        result = null;
    }

    return typeof callback === 'function'
        ? callback(result)
        : dispatch({
              type: SET_STOREBRAND_INFO,
              data: mapStorebrandData(result),
          });
};

/******************************************************************************
 ******************************************************************************/
export const getStorebrandTransaction =
    (
        config: {
            id?: string;
            fromDate: Date;
            toDate: Date;
        },
        callback?: (result: unknown) => void
    ) =>
    async (dispatch: TDispatch) => {
        let result = null;
        if (!config.id || !config.fromDate || !config.toDate) {
            return typeof callback === 'function'
                ? callback(result)
                : dispatch({ type: SET_STOREBRAND_TRANSACTION, data: result });
        }

        const interval = [config.fromDate.toISOString().slice(0, 10), config.toDate.toISOString().slice(0, 10)];
        const url = `${baseUrlFond}/${config.id}/transactions/${interval[0]}/${interval[1]}`;

        try {
            result = await get(url).catch(() => null);
        } catch (error) {
            result = null;
        }

        return typeof callback === 'function'
            ? callback(result)
            : dispatch({ type: SET_STOREBRAND_TRANSACTION, data: result });
    };

export const setStorebrandTransaction = (data: unknown) => async (dispatch: TDispatch) => {
    return dispatch({ type: SET_STOREBRAND_TRANSACTION, data });
};

/******************************************************************************
 ******************************************************************************/
export const getStorebrandPensionPayout =
    (
        config: {
            id?: string;
            age?: string;
        },
        callback?: (result: unknown) => void
    ) =>
    async (dispatch: TDispatch) => {
        let result = null;
        if (!config.id || !config.age) {
            return typeof callback === 'function'
                ? callback(result)
                : dispatch({ type: SET_STOREBRAND_PENSION_PAYOUT, data: result });
        }

        const url = `${baseUrlFond}/${config.id}/estimatedPayouts/${config.age}`;
        try {
            result = await get(url).catch(() => null);
        } catch (error) {
            result = null;
        }

        return typeof callback === 'function'
            ? callback(result)
            : dispatch({ type: SET_STOREBRAND_PENSION_PAYOUT, data: result });
    };

export const setStorebrandPensionPayout = (data: unknown) => async (dispatch: TDispatch) => {
    return dispatch({ type: SET_STOREBRAND_PENSION_PAYOUT, data });
};

/******************************************************************************
 ******************************************************************************/

const initialState = {
    signingConfig: undefined,
};

export const switchStorebrandSavingsProfile =
    (switchStorebrandSavingsProfilePayload: SwitchStorebrandSavingsProfilePayload) => async (dispatch: TDispatch) => {
        const { contractNumber, selectedProfileIsin, automaticDownscaling } = switchStorebrandSavingsProfilePayload;
        const url = `${baseUrlFond}/switch-profile/${contractNumber}`;

        return post<SwitchStorebrandSavingsProfileResponseApi>(url, { selectedProfileIsin, automaticDownscaling }).then(
            (response) => {
                dispatch({ type: SET_STOREBRAND_INFO, data: mapStorebrandData(response.eikaPensionContracts) });
                return response;
            }
        );
    };

export default (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case SET_STOREBRAND_INFO:
            return { ...state, info: action.data };
        case SET_STOREBRAND_TRANSACTION:
            return { ...state, transaction: action.data };
        case SET_STOREBRAND_PENSION_PAYOUT:
            return { ...state, payout: action.data };
        default:
            return state;
    }
};
